const PNP_REFRESH_V1 = 'GROW-2792';
const DESC_MESSAGE = '[Type: String][Vis.: high] - form features summary - A string in pricing experiment GROW-2792';

const experimentSummaryCopy = {
  grow_2792_skip_logic: {
    id: 'Pricing.experimentSummaryCopy.JustSkipLogic',
    defaultMessage: 'Skip logic',
    desc: {
      id: 'Pricing.experimentSummaryCopy.JustSkipLogic',
      message: `${DESC_MESSAGE} - SkipLogic`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_create_custom_theme_enabled: {
    id: 'Pricing.experimentSummaryCopy.CreateCustomThemesEnabled',
    defaultMessage: 'Custom themes, colors, and more',
    desc: {
      id: 'Pricing.experimentSummaryCopy.CreateCustomThemesEnabled',
      message: `${DESC_MESSAGE} - CreateCustomThemesEnabled`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_single_user: {
    id: 'Pricing.experimentSummaryCopy.SingleUser',
    defaultMessage: 'Single user',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SingleUser',
      message: `${DESC_MESSAGE} - SingleUser`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_team_collaboration_user: {
    id: 'Pricing.experimentSummaryCopy.TeamCollaborationUser',
    defaultMessage: 'Team collaboration with 3+ users',
    desc: {
      id: 'Pricing.experimentSummaryCopy.TeamCollaborationUser',
      message: `${DESC_MESSAGE} - TeamCollaborationUser`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_advanced_team_collaboration_user: {
    id: 'Pricing.experimentSummaryCopy.AdvancedTeamCollaborationUser',
    defaultMessage: 'Advanced team collaboration',
    desc: {
      id: 'Pricing.experimentSummaryCopy.AdvancedTeamCollaborationUser',
      message: `${DESC_MESSAGE} - AdvancedTeamCollaborationUser`,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_survey_create_limit: {
    id: 'Pricing.experimentSummaryCopy.SurveyFormsCreateLimit',
    defaultMessage: 'Unlimited number of surveys and forms',
    desc: {
      id: 'Pricing.experimentSummaryCopy.SurveyFormsCreateLimit',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_unlimited_questions: {
    id: 'Pricing.experimentSummaryCopy.UnlimitedFieldsPerForm',
    defaultMessage: 'Unlimited questions per survey/Unlimited fields per form',
    desc: {
      id: 'Pricing.experimentSummaryCopy.UnlimitedFieldsPerForm',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_forms_question_types: {
    id: 'Pricing.experimentSummaryCopy.FormsQuestionTypes',
    defaultMessage: 'Form question types',
    desc: {
      id: 'Pricing.experimentSummaryCopy.FormsQuestionTypesDesc',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_all_question_types: {
    id: 'Pricing.experimentSummaryCopy.AllQuestionTypes',
    defaultMessage: 'All question types',
    desc: {
      id: 'Pricing.experimentSummaryCopy.AllQuestionTypesDesc',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_analyze_export_enabled: {
    id: 'Pricing.experimentSummaryCopy.AnalyzeExportEnabled',
    defaultMessage: 'Data exports (CSV, PDF, PPT, XLS)',
    desc: {
      id: 'Pricing.experimentSummaryCopy.AnalyzeExportEnabledDesc',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_website_embed: {
    id: 'Pricing.experimentSummaryCopy.WebsiteEmbed',
    defaultMessage: 'Website embed',
    desc: {
      id: 'Pricing.experimentSummaryCopy.WebsiteEmbed',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_zapier_integrations: {
    id: 'Pricing.experimentSummaryCopy.ZapierIntegrations',
    defaultMessage: '5000+ integrations with Zapier',
    desc: {
      id: 'Pricing.experimentSummaryCopy.ZapierIntegrations',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_text_analysis: {
    id: 'Pricing.experimentSummaryCopy.TextAnalysis',
    defaultMessage: 'Text Analysis',
    desc: {
      id: 'Pricing.experimentSummaryCopy.TextAnalysis',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
  grow_2792_a_b_testing: {
    id: 'Pricing.experimentSummaryCopy.ABTesting',
    defaultMessage: 'A/B testing & Statistical Significance',
    desc: {
      id: 'Pricing.experimentSummaryCopy.ABTesting',
      message: DESC_MESSAGE,
      project: PNP_REFRESH_V1,
    },
  },
};

export default experimentSummaryCopy;
